
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","width":"12","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticStyle:{"mix-blend-mode":"passthrough"}},[_c('path',{attrs:{"d":"M7.704 6q0 .083-.008.167-.008.083-.024.165-.017.082-.041.162t-.056.158q-.032.077-.072.15-.04.075-.086.144-.046.07-.1.135-.053.064-.112.124-.06.059-.124.112-.065.053-.134.1-.07.046-.144.086-.073.04-.15.071-.078.032-.158.056-.08.025-.163.041-.082.016-.165.025-.083.008-.167.008t-.167-.008q-.083-.009-.166-.025-.082-.016-.162-.04-.08-.025-.157-.057-.078-.032-.152-.071-.073-.04-.143-.086-.07-.047-.134-.1-.065-.053-.124-.112-.06-.06-.113-.124-.053-.065-.1-.135-.046-.07-.085-.143-.04-.074-.072-.151-.032-.078-.056-.158t-.04-.162q-.017-.082-.025-.165-.008-.084-.008-.168 0-.083.008-.167.008-.083.024-.165.017-.082.04-.162.025-.08.057-.158.032-.077.072-.151.04-.074.086-.143.046-.07.1-.135.053-.064.112-.124.059-.059.124-.112.064-.053.134-.1.07-.046.143-.086.074-.04.152-.071.077-.032.157-.057.08-.024.162-.04.083-.016.166-.025.083-.008.167-.008t.167.008q.083.009.165.025.083.016.163.04.08.025.157.057.078.032.151.071.074.04.144.086.07.047.134.1.065.053.124.112.06.06.112.124.054.065.1.135.047.07.086.143.04.074.072.151.032.078.056.158t.04.162q.017.082.025.165.008.084.008.167z","fill":"#FFF"}}),_c('path',{attrs:{"d":"M10.667 6Q8.514 3.259 6 3.259T1.333 6Q3.486 8.741 6 8.741T10.667 6zM6 9.541q3.078 0 5.584-3.426a.194.194 0 000-.23Q9.078 2.459 6 2.459T.416 5.885a.194.194 0 000 .23Q2.922 9.541 6 9.541z","fill-rule":"evenodd","fill":"#FFF"}})])])
          )
        }
      }
    